<template>
  <div id="app" :class="{'hide-arrows': hideArrows, 'home': true}">
    <app-header></app-header>
    <full-page ref="fullpage" :options="options" id="fullpage" :skip-init="true">
      <div class="section" data-anchor="page" v-on:pointermove="handleMouseOver">
        <template v-for="slide in slides">
          <app-home :key="slide.id" :slide="slide" v-if="slide.type === 'home'"></app-home>
          <app-subtitle :key="slide.id" :slide="slide" v-if="slide.type === 'subtitle'"></app-subtitle>
          <app-photo :key="slide.id" :slide="slide" :photo="slide.photo" :fullscreen="slide.fullscreen" v-if="slide.type === 'photo'" @openLightbox="showGallery"></app-photo>
          <app-video :key="slide.id" :slide="slide" :photo="slide.photo" :video="slide.video" :details="slide.details" v-if="slide.type === 'video'"></app-video>
          <app-audio :key="slide.id" :slide="slide" :photo="slide.photo" :audio="slide.audio" :details="slide.details" v-if="slide.type === 'audio'"></app-audio>
          <app-zoom :key="slide.id" :slide="slide" :photo="slide.photo" :video="slide.video" :details="slide.details" v-if="slide.type === 'zoom'" @setAllowScrolling="setAllowScrolling"></app-zoom>
          <app-pdf :key="slide.id" :slide="slide" v-if="slide.type === 'pdf'"></app-pdf>
          <app-gallery :key="slide.id" :slide="slide" :window="window" v-if="slide.type === 'gallery'" @openLightbox="showGallery"></app-gallery>
          <app-end :key="slide.id" :slide="slide" :photo="slide.photo" :details="slide.details" v-if="slide.type === 'end'"></app-end>
        </template>
      </div>
    </full-page>

    <LightGallery
      :images="photos"
      :index="galleryIndex"
      :disable-scroll="true"
      @close="hideGallery"
    />  
    <slideout-panel></slideout-panel>
  </div>
</template>

<script>
import axios from 'axios'
import AppHeader from './components/Header'
import AppHome from './components/Home'
import AppSubtitle from './components/Subtitle'
import AppPhoto from './components/Photo'
import AppVideo from './components/Video'
import AppAudio from './components/Audio'
import AppZoom from './components/Zoom'
import AppPdf from './components/Pdf'
import AppGallery from './components/Gallery'
import AppEnd from './components/End'
import LightGallery from './light-gallery';

export default {
  name: 'App',
  components: {
    AppHeader, AppHome, AppSubtitle, AppPhoto, AppVideo, AppAudio, AppZoom, AppPdf, AppGallery, AppEnd, LightGallery
  },
  mixins: [],
  data() {
    return {
      options: {
        licenseKey: 'DC2B8A6F-85A5457C-92AB6429-F7773B0D',
        scrollHorizontallyKey: 'bWctbGouc2lfM09qYzJOeWIyeHNTRzl5YVhwdmJuUmhiR3g1NWQz',
        //menu: '#menu',
        scrollHorizontally: true,
        // afterSlideLoad: this.afterSlideLoad,
        // onSlideLeave: this.onSlideLeave,
        loopHorizontal: true,
        scrollOverflow: true,
        lazyLoading: true,
        autoScrolling: false,
        //keyboardScrolling: true,
        controlArrows: true
      },
      window: {
        width: 0,
        height: 0
      },
      slides: [],
      photos: [],
      galleryIndex: null,
      slideOutPanel: null,
      isSlideoutOpen: false,
      arrowsTimeout: null,
      hideArrows: false,
      alternateLang: 'en',
      alternateHref: '#'
    }
  },
  methods: {
    afterSlideLoad() {
      // console.log('After Load APP');
    },
    //onSlideLeave(data) {
    onSlideLeave() {
      // console.log('On slide leave App', data);
      //return false;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleMouseOver() {
      /*
      this.hideArrows = false;
      clearTimeout(this.arrowsTimeout);
      this.arrowsTimeout = setTimeout(() => {
        this.hideArrows = true;
      }, 400);
      */
    },
    restart() {
      // go to first slide
      this.$refs.fullpage.api.moveTo(1, 0);
    },
    goToSlide(numSlide = 2) {
      this.$refs.fullpage.api.moveTo(1, numSlide);
    },
    showGallery(e) {
      //this.$refs.fullpage.api.setAllowScrolling(false)
      //this.$refs.fullpage.api.setKeyboardScrolling(false)
      this.photos = e.photos
      this.galleryIndex = e.index
    },
    hideGallery() {
      //this.$refs.fullpage.api.setAllowScrolling(true)
      //his.$refs.fullpage.api.setKeyboardScrolling(true)
      this.galleryIndex = null
    },
    setAllowScrolling(val) {
      this.$refs.fullpage.api.setAllowScrolling(val);
    },
    reBuild() {
      console.log('rrebuild')
      this.$refs.fullpage.api.console()
    }
  },
  created() {
    // detect alternate language
    let links = document.getElementsByTagName("link");
    if (process.env.NODE_ENV === 'production' && !process.env.CI_PROJECT_NAME) {
      for ( var i = 0; i < links.length; i++ ) {
        if (links[i].getAttribute("rel") === 'alternate') {
          this.alternateHref = links[i].getAttribute("href");
          this.alternateLang = links[i].getAttribute("hreflang");
          if (this.alternateLang === 'si') {
            this.alternateLang === 'sl'
          }
        }
      }
    }

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    // load data
    let srcUrl = './slides.json';
    if (process.env.NODE_ENV === 'production' && !process.env.CI_PROJECT_NAME) {
      let url = window.location.href.split('/')
      srcUrl = 'https://www.mg-lj.si/' + url[3] + '/json/?id=' + url[5]
    }
    
    //axios.get()
    axios.get(srcUrl)
      .then(response => {
        this.slides = response.data
        this.$nextTick(function () {
          this.$refs.fullpage.init()
          //this.$refs.fullpage.api.setAllowScrolling(true)
        })
      });
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },  
  mounted() {
    // lock screen orientation
    // screen.orientation.lock("portrait");
    this.index = 0
    this.$root.$on('openSlidePanel', (val) => {
      this.slideOutPanel = this.$showPanel({
        component: 'slide-panel',
        openOn: 'bottom',
        height: '80%',
        cssClass: 'my-slide-panel',
        props: {
          body: val
        }
      })
      //this.$refs.fullpage.api.setAllowScrolling(false)
      //this.$refs.fullpage.api.setKeyboardScrolling(false)
      this.slideOutPanel.promise
        .then(() => {
          console.log('Panel closed!')
          //this.$refs.fullpage.api.setAllowScrolling(true)
          //this.$refs.fullpage.api.setKeyboardScrolling(true)
        })
    })

    this.$root.$on('goToNextSlide', () => {
      this.$refs.fullpage.api.moveSlideRight()
    })

    this.$root.$on('goToSlide', (val) => {
      console.log('goToSlide event', val);
      this.goToSlide(val);
    })

    window.addEventListener('keydown', (e) => {
      console.log('move', e)
      if (this.galleryIndex === null && !this.isSlideoutOpen) {
        if (e.code == 'ArrowRight') {
          this.$refs.fullpage.api.moveSlideRight()
        } else if (e.code == 'ArrowLeft') {
          this.$refs.fullpage.api.moveSlideLeft()
        }
      }
    });
  },
  watch: {}
}
</script>

<style>
body, html {
  margin: 0;
  padding: 0;
  background: #555555;
}
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff;
  position: relative;
}
</style>
